import React from 'react';

import { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  FormControlLabel,
  Autocomplete,
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import { useMediaQuery, useTheme } from "@mui/material";
import axiosInstanceMainUrl from '../../utils/axiosInstanceMainUrl';

const EntityRegistrationForm = ({ setShowForm }) => {
  const mainUrl = import.meta.env.VITE_MAIN_URL 
  // const mainUrl = "https://uat.batuk.in";

  const [states, setStates] = useState([]);
  const [stateId, setstateId] = useState("");
  const [showMessage, setshowMessage] = useState("");

  const [cities, setCities] = useState([]);
  const [formData, setFormData] = useState({
    EntityType: "",
    Entityname: "",
    EntityidentificationNo: "",
    Entityemail: "",
    password: "",
    confirmPassword: "",
    panNo: "",
    Gstin: "",
    authpersonName: "",
    mobileNo: "",
    companyAddress: "",
    country: "",
    state: "", // Storing state name here
    city: "", // Storing city name here
    pincode: "",
    accHoldername: "",
    accNo: "",
    confirmaccNo: "",
    Ifsccode: "",
    registerType: "entity",
  });

  const [errors, setErrors] = useState({});
  const [termsAccepted, setTermsAccepted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    let formErrors = {};

    if (!formData.EntityType) formErrors.EntityType = "Entity type is required";
    if (!formData.Entityname) formErrors.Entityname = "Entity name is required";
    if (!formData.EntityidentificationNo)
      formErrors.EntityidentificationNo =
        "Entity identification number is required";
    if (!formData.Entityemail) formErrors.Entityemail = "Email is required";
    if (!formData.password) formErrors.password = "Password is required";
    if (formData.password !== formData.confirmPassword)
      formErrors.confirmPassword = "Passwords do not match";
    if (!formData.panNo) formErrors.panNo = "PAN number is required";
    if (!formData.Gstin) formErrors.Gstin = "GSTIN is required";
    if (!formData.authpersonName)
      formErrors.authpersonName = "Authorized person's name is required";
    if (!formData.mobileNo) formErrors.mobileNo = "Mobile number is required";
    if (!formData.companyAddress)
      formErrors.companyAddress = "Company address is required";
    if (!formData.country) formErrors.country = "Country is required";
    if (!formData.state) formErrors.state = "State is required"; // State name validation
    if (!formData.city) formErrors.city = "City is required"; // City name validation
    if (!formData.pincode) formErrors.pincode = "Pincode is required";
    if (!formData.accHoldername)
      formErrors.accHoldername = "Account holder's name is required";
    if (!formData.accNo) formErrors.accNo = "Account number is required";
    if (formData.accNo !== formData.confirmaccNo)
      formErrors.confirmaccNo = "Account numbers do not match";
    if (!formData.Ifsccode) formErrors.Ifsccode = "IFSC code is required";
    if (!termsAccepted)
      formErrors.termsAccepted = "You must accept the terms and conditions";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  useEffect(() => {
    const url = `/augmontGold/states`;
    // const url = `${mainUrl}/augmontGold/states`;

    axiosInstanceMainUrl
      .get(url)
      .then((response) => setStates(response.data.data))
      .catch((error) => console.error("Error fetching states:", error));
  }, []);

  // Fetch cities based on selected state
  useEffect(() => {
    if (stateId) {
      const url = `/augmontGold/city/${stateId}`;
      // const url = `${mainUrl}/augmontGold/city/${stateId}`;
      axiosInstanceMainUrl
        .get(url)
        .then((response) => setCities(response.data.data))
        .catch((error) => console.error("Error fetching cities:", error));
    }
  }, [stateId]);

  const handleStateChange = (event, value) => {
    setFormData({
      ...formData,
      state: value ? value.name : "",
      city: "", // Reset city when state changes
    });
    setstateId(value.id);
    setCities([]); // Clear cities until new data is fetched
  };

  const handleCityChange = (event, value) => {
    setFormData({
      ...formData,
      city: value ? value.name : "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      finalSubmit();
    }
  };
  const finalSubmit = async () => {
    try {
      const url = `/partner_registeration`;
      // const url = `${mainUrl}/partner_registeration`;

      const response = await axiosInstanceMainUrl.post(url, formData);
      // const response = await axios.post(url, formData);
      setshowMessage(response?.data?.message);
      if (response.data.message == "Partner registered successfully") {
        setShowForm(true);
        toast.success("Partner registered successfully");
        setFormData({
          name: "",
          email: "",
          dob: "",
          mobileNo: "",
          password: "",
          confirmPassword: "",
          Address: "",
          state: "",
          city: "",
          pincode: "",
          aadharNo: "",
          panNo: "",
          accHoldername: "",
          accNo: "",
          confirmaccNo: "",
          Ifsccode: "",
        });
        // setValidated(false);
        setTermsAccepted(false);
        setstateId("");
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

   const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check
  

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3} padding={isMobile?0:3}>
        <Grid item xs={12}>
          <Typography variant="h5" >
            Register as Entity Partner
          </Typography>
        </Grid>

        {/* Entity Type Selection */}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth error={!!errors.EntityType}>
            <InputLabel>Entity Type</InputLabel>
            <Select

              size="small"
              label="Entity Type"
              name="EntityType"
              value={formData.EntityType}
              onChange={handleChange}
              required
            >
              <MenuItem value="">Select</MenuItem>
              <MenuItem value="Individual Company">Individual Company</MenuItem>
              <MenuItem value="Sole Proprietorship">
                Sole Proprietorship
              </MenuItem>
              <MenuItem value="Partnership">Partnership</MenuItem>
              <MenuItem value="Private Limited">Private Limited</MenuItem>
              <MenuItem value="Public Limited">Public Limited</MenuItem>
              <MenuItem value="LLP">
                LLP (Limited Liability Partnership)
              </MenuItem>
              <MenuItem value="Trust">Trust</MenuItem>
              <MenuItem value="Society">Society</MenuItem>
              <MenuItem value="Government">Government</MenuItem>
              <MenuItem value="Hindu Undivided Family">
                Hindu Undivided Family
              </MenuItem>
              <MenuItem value="Local Authority">Local Authority</MenuItem>
              <MenuItem value="NGO">NGO</MenuItem>
              <MenuItem value="One Person Company">One Person Company</MenuItem>
              <MenuItem value="Artificial Juridical Person">
                Artificial Juridical Person
              </MenuItem>
            </Select>
            {errors.EntityType && (
              <Typography variant="body2" color="error">
                {errors.EntityType}
              </Typography>
            )}
          </FormControl>
        </Grid>

        {/* Entity Name */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Company / Entity Name"
            name="Entityname"
            value={formData.Entityname}
            onChange={handleChange}
            error={!!errors.Entityname}
            helperText={errors.Entityname}
            fullWidth
            required
          />
        </Grid>

        {/* Entity Identification No. */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Entity Identification No."
            name="EntityidentificationNo"
            value={formData.EntityidentificationNo}
            onChange={handleChange}
            error={!!errors.EntityidentificationNo}
            helperText={errors.EntityidentificationNo}
            fullWidth
          />
        </Grid>

        {/* Email */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Email"
            name="Entityemail"
            value={formData.Entityemail}
            onChange={handleChange}
            error={!!errors.Entityemail}
            helperText={errors.Entityemail}
            fullWidth
          />
        </Grid>

        {/* Password */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Password"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            error={!!errors.password}
            helperText={errors.password}
            fullWidth
          />
        </Grid>

        {/* Confirm Password */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword}
            fullWidth
          />
        </Grid>

        {/* PAN Number */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="PAN No."
            name="panNo"
            value={formData.panNo}
            onChange={handleChange}
            error={!!errors.panNo}
            helperText={errors.panNo}
            fullWidth
          />
        </Grid>

        {/* GSTIN */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="GSTIN"
            name="Gstin"
            value={formData.Gstin}
            onChange={handleChange}
            error={!!errors.Gstin}
            helperText={errors.Gstin}
            fullWidth
          />
        </Grid>

        {/* Authorized Person Name */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Authorized Person Name"
            name="authpersonName"
            value={formData.authpersonName}
            onChange={handleChange}
            error={!!errors.authpersonName}
            helperText={errors.authpersonName}
            fullWidth
          />
        </Grid>

        {/* Mobile Number */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Mobile No."
            name="mobileNo"
            value={formData.mobileNo}
            onChange={handleChange}
            error={!!errors.mobileNo}
            helperText={errors.mobileNo}
            fullWidth
          />
        </Grid>

        {/* Company Address */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Company Address"
            name="companyAddress"
            value={formData.companyAddress}
            onChange={handleChange}
            error={!!errors.companyAddress}
            helperText={errors.companyAddress}
            fullWidth
          />
        </Grid>

        {/* Country */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Country"
            name="country"
            value={formData.country}
            onChange={handleChange}
            error={!!errors.country}
            helperText={errors.country}
            fullWidth
          />
        </Grid>

        {/* State */}
        {/* <Grid item xs={12} md={6}>
          <TextField
          size="small"
            label="State"
            name="state"
            value={formData.state}
            onChange={handleChange}
            error={!!errors.state}
            helperText={errors.state}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
          size="small"
            label="City"
            name="city"
            value={formData.city}
            onChange={handleChange}
            error={!!errors.city}
            helperText={errors.city}
            fullWidth
          />
        </Grid> */}

        <Grid item xs={12} md={6}>
          <Autocomplete
            size="small"
            options={states}
            getOptionLabel={(option) => option?.name}
            onChange={handleStateChange}
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                label="State"
                name="state"
                required
                error={!!errors.state}
                helperText={errors.state}

              // error={validated && !formData?.state}
              // helperText={
              //   validated && !formData?.state ? "State is required." : ""
              // }
              />
            )}
          />
        </Grid>
        {/* City Selection */}
        <Grid item xs={12} md={6}>
          <Autocomplete
            size="small"
            options={cities}
            getOptionLabel={(option) => option?.name}
            onChange={handleCityChange}
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                label="City"
                name="city"
                required
                error={!!errors.city}
                helperText={errors.city}
              // error={validated && !formData.city}
              // helperText={
              //   validated && !formData.city ? "City is required." : ""
              // }
              />
            )}
          />
        </Grid>

        {/* Pincode */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Pincode"
            name="pincode"
            value={formData.pincode}
            onChange={handleChange}
            error={!!errors.pincode}
            helperText={errors.pincode}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Account Holder's Name"
            name="accHoldername"
            value={formData.accHoldername}
            onChange={handleChange}
            required
            fullWidth
            error={!!errors.accHoldername}
            helperText={errors.accHoldername}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Account No."
            name="accNo"
            type="text"
            value={formData.accNo}
            onChange={handleChange}
            required
            fullWidth
            error={!!errors.accNo}
            helperText={errors.accNo}
          // error={validated && !formData.accNo}
          // helperText={
          //   validated && !formData.accNo ? "Account no. is required." : ""
          // }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="Confirm Account No."
            name="confirmaccNo"
            type="text"
            value={formData.confirmaccNo}
            onChange={handleChange}
            required
            fullWidth
            error={!!errors.confirmaccNo}
            helperText={errors.confirmaccNo}
          // error={validated && formData.accNo !== formData.confirmaccNo}
          // helperText={
          //   validated && formData.accNo !== formData.confirmaccNo
          //     ? "Account numbers do not match."
          //     : ""
          // }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            label="IFSC Code"
            name="Ifsccode"
            type="text"
            value={formData.Ifsccode}
            onChange={handleChange}
            required
            fullWidth
            error={!!errors.Ifsccode}
            helperText={errors.Ifsccode}
          // error={validated && !formData.Ifsccode}
          // helperText={
          //   validated && !formData.Ifsccode ? "IFSC code is required." : ""
          // }
          />
        </Grid>

        {/* Terms & Conditions */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={termsAccepted}
                onChange={(e) => setTermsAccepted(e.target.checked)}
                name="termsAccepted"
              />
            }
            label="I agree to the terms and conditions"
          />
          {errors.termsAccepted && (
            <Typography variant="body2" color="error">
              {errors.termsAccepted}
            </Typography>
          )}
        </Grid>

        {/* Submit Button */}
        <Grid item xs={12}>
          <Button type="submit" variant="contained" color="primary" fullWidth>
            Submit
          </Button>
        </Grid>
      </Grid>
      <Typography>{showMessage}</Typography>
    </form>
  );
};

export default EntityRegistrationForm;
